import { HomePageContextProvider, LeisureContextProvider, LeisureHomePage, LeisureShowPage } from 'components';
import { ProtectedRoute } from 'router';

export const leisureSportRoutes = {
  leisureHomePage: {
    path: '/parcs-loisirs',
    component: () => (
      <ProtectedRoute>
        <HomePageContextProvider>
          <LeisureHomePage pageType="leisures" />
        </HomePageContextProvider>
      </ProtectedRoute>
    )
  },
  leisureShow: {
    path: '/parcs-loisirs/:id',
    component: () => (
      <ProtectedRoute>
        <LeisureContextProvider>
          <LeisureShowPage />
        </LeisureContextProvider>
      </ProtectedRoute>
    )
  },
  sportHomePage: {
    path: '/sport-bien-etre',
    component: () => (
      <ProtectedRoute>
        <HomePageContextProvider>
          <LeisureHomePage pageType="sport" />
        </HomePageContextProvider>
      </ProtectedRoute>
    )
  },
  sportShow: {
    path: '/sport-bien-etre/:id',
    component: () => (
      <ProtectedRoute>
        <LeisureContextProvider>
          <LeisureShowPage />
        </LeisureContextProvider>
      </ProtectedRoute>
    )
  }
};
